import { Grid, Icon, IconButton } from '@material-ui/core';
import React from 'react';
import DisplayError from '../DisplayData/DisplayError';
import RoundedButton from './RoundedButton';
//import RoundedButton from './RoundedButton';

const ActionModalBar = ({btnLabel, loading, btnColor, error, onSubmit, onDelete, disabled, onCloseError}) => {
    return ( 
        <Grid container>
            <Grid item xs={12}>
                {error ? <DisplayError text={error} onClose={onCloseError} /> : null}
            </Grid>
            <Grid item xs={12}>
                <Grid container justifyContent='flex-end'>
                    {onDelete ? (
                        <Grid item><IconButton onClick={onDelete} ><Icon>delete</Icon></IconButton>  </Grid>
                    ) : null}
                    <Grid item xs></Grid>
                    <Grid item>
                        <RoundedButton loading={loading} color={btnColor} onClick={onSubmit} disabled={disabled} >{btnLabel}</RoundedButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
     );
}
 
export default ActionModalBar;